
        Component.define('side-menu', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

// $('.close-menu').on('click', function(){
//     $(this).parent().removeClass('collapsed');
// });

$('.open-menu').on('click', function(){
    $('.side-menu').toggleClass('collapsed');
    $(this).toggleClass('is-active');
});

$('.side-menu .youshare').on('click', function(e){
    e.preventDefault();
});

$('.side-menu ul > li').on('click', function(e){
    $(this).toggleClass('collapsed');
    $(this).find('ul').slideToggle();
});

        });